const mutations = {
  setModels(state, data) {
    state.examens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.examen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.examens.unshift(model);
  },

  updateModel(state, model) {
    state.provincia = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.examens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.examens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
